import { FeeAmount } from '@kodiak-finance/v3-sdk'
import { ALL_SUPPORTED_CHAIN_IDS, SupportedChainId } from 'config/chains'
import type { ReactNode } from 'react'

export const FEE_AMOUNT_DETAIL: Record<
  FeeAmount,
  { label: string; description: ReactNode; supportedChains: SupportedChainId[] }
> = {
  [FeeAmount.LOWEST]: {
    label: '0.01',
    description: <>Best for very stable pairs.</>,
    supportedChains: ALL_SUPPORTED_CHAIN_IDS,
  },
  [FeeAmount.LOW]: {
    label: '0.05',
    description: <>Best for stable pairs.</>,
    supportedChains: ALL_SUPPORTED_CHAIN_IDS,
  },
  [FeeAmount.MEDIUM]: {
    label: '0.3',
    description: <>Best for most pairs.</>,
    supportedChains: ALL_SUPPORTED_CHAIN_IDS,
  },
  [FeeAmount.HIGH]: {
    label: '1',
    description: <>Best for exotic pairs.</>,
    supportedChains: ALL_SUPPORTED_CHAIN_IDS,
  },
  [FeeAmount.EXTRA]: {
    label: '2',
    description: <>Best for new tokens.</>,
    supportedChains: ALL_SUPPORTED_CHAIN_IDS,
  },
}
